export default __webpack_public_path__ + "static/media/clareamento-ball.b548df3e.png";